import { createSelector } from 'reselect'

import { getDashboardState } from '../../../duck/selectors'
import { ORGANIZATION_DETAILS_MODAL_STORE_ID } from './types'

export const getOrganizationDetailsModalState = createSelector(
  getDashboardState,
  (dashboardState) => dashboardState.components[ORGANIZATION_DETAILS_MODAL_STORE_ID]
)

export const isAdminOrganizationDetailsModalState = createSelector(
  getOrganizationDetailsModalState,
  (modalState) => modalState.isAdmin
)

export const isOrganizationDetailsModalOpen = createSelector(
  getOrganizationDetailsModalState,
  (modalState) => modalState.show
)
